export const ADD_REMINDER = 'ADD_REMINDER'
export const REMOVE_REMINDER = 'REMOVE_REMINDER'
export const CLEAR_REMINDERS = 'CLEAR_REMINDERS'
export const EDIT_REMINDER = 'EDIT_REMINDER'